import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrowserBroken = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 122,
	height: 76,
	viewBox: "0 0 122 76",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 121,
			height: 76,
			transform: "translate(0.5)",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M85.2393 54.9485C83.4263 52.5163 83.9323 49.0778 86.3694 47.2684L96.3189 39.8817L114.501 64.2727L112.791 66.091L98.5445 56.8547L99.9765 63.386L90.5552 58.8956L89.0272 60.03L85.2393 54.9485ZM87.8845 49.301C86.5722 50.2752 86.2998 52.1267 87.276 53.4364L89.5488 56.4853L90.2681 55.9513L96.3874 58.8679L94.7434 51.3693L108.242 60.1207L95.7973 43.4264L87.8845 49.301Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M88.6636 70.0586L77.2485 69.3278L92.9542 61.695L88.6636 70.0586ZM88.1837 66.3616L85.364 67.7319L87.4134 67.8631L88.1837 66.3616Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M101.183 61.818L105.145 63.9747L105.145 72.5678L98.4045 69.5386L101.183 61.818ZM102.339 64.8518L101.056 68.4151L103.03 69.3019L103.03 65.228L102.339 64.8518Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.7302 68.4007C11.9916 68.4007 8.96094 65.3761 8.96094 61.6451V13.0895C8.96094 9.35855 11.9916 6.33398 15.7302 6.33398H69.884C71.4137 6.33398 72.8249 6.84035 73.9584 7.69427L70.3566 9.85098L65.5787 12.3677L72.0804 15.298L72.1185 15.6088L57.4848 21.5836H73.2686V21.5562L76.6532 21.734V61.6451C76.6532 65.3761 73.6226 68.4007 69.884 68.4007H15.7302ZM15.7302 9.71176H65.1826L59.8042 12.5448L66.0379 15.3543L50.7809 21.5836H12.3456V13.0895C12.3456 11.224 13.8609 9.71176 15.7302 9.71176ZM73.2686 24.9614V61.6451C73.2686 63.5106 71.7533 65.0229 69.884 65.0229H15.7302C13.8609 65.0229 12.3456 63.5106 12.3456 61.6451V24.9614H73.2686ZM19.7077 15.4834C19.7077 16.5759 18.8228 17.4616 17.7313 17.4616C16.6397 17.4616 15.7549 16.5759 15.7549 15.4834C15.7549 14.3908 16.6397 13.5051 17.7313 13.5051C18.8228 13.5051 19.7077 14.3908 19.7077 15.4834ZM27.6135 15.4834C27.6135 16.5759 26.7287 17.4616 25.6371 17.4616C24.5456 17.4616 23.6607 16.5759 23.6607 15.4834C23.6607 14.3908 24.5456 13.5051 25.6371 13.5051C26.7287 13.5051 27.6135 14.3908 27.6135 15.4834ZM30.7015 41.2002C32.3388 41.2002 33.6661 39.8717 33.6661 38.2328C33.6661 36.594 32.3388 35.2655 30.7015 35.2655C29.0641 35.2655 27.7368 36.594 27.7368 38.2328C27.7368 39.8717 29.0641 41.2002 30.7015 41.2002ZM57.6301 38.2328C57.6301 39.8716 56.3028 41.2001 54.6655 41.2001C53.0282 41.2001 51.7009 39.8716 51.7009 38.2328C51.7009 36.594 53.0282 35.2655 54.6655 35.2655C56.3028 35.2655 57.6301 36.594 57.6301 38.2328ZM34.4073 56.7781C34.4073 55.3625 35.2916 54.0145 36.8594 52.9966C38.4225 51.9818 40.6112 51.338 43.0542 51.338C45.4971 51.338 47.6859 51.9818 49.2489 52.9966C50.8167 54.0145 51.701 55.3625 51.701 56.7781C51.701 57.0512 51.9222 57.2727 52.1951 57.2727C52.468 57.2727 52.6892 57.0512 52.6892 56.7781C52.6892 54.9161 51.5272 53.2968 49.7867 52.1667C48.0413 51.0336 45.6596 50.3489 43.0542 50.3489C40.4487 50.3489 38.067 51.0336 36.3217 52.1667C34.5811 53.2968 33.4191 54.9161 33.4191 56.7781C33.4191 57.0512 33.6404 57.2727 33.9132 57.2727C34.1861 57.2727 34.4073 57.0512 34.4073 56.7781ZM35.5191 15.4834C35.5191 16.5759 34.6343 17.4616 33.5427 17.4616C32.4512 17.4616 31.5663 16.5759 31.5663 15.4834C31.5663 14.3908 32.4512 13.5051 33.5427 13.5051C34.6343 13.5051 35.5191 14.3908 35.5191 15.4834Z",
			fill: "#8F8E90"
		})
	]
});
export default SvgBrowserBroken;
